import { render } from "./SuggestionManagerSources.vue?vue&type=template&id=2d5f99f8"
import script from "./SuggestionManagerSources.vue?vue&type=script&lang=js"
export * from "./SuggestionManagerSources.vue?vue&type=script&lang=js"

import "./SuggestionManagerSources.vue?vue&type=style&index=0&id=2d5f99f8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__